// Interfaces
import { IRouteParent } from 'routes/route.interface'

// Constant
import { MASTER_MODULE, MASTER_URL } from 'constant/url.constant'
import { ACCESS_CODE_MASTER_DATA } from 'constant/access.constant'

// Company
import { companyRoutes } from './company.router'

// Branch
import { branchRoutes } from './branch.router'

// Role
import { roleRoutes } from './role.router'

// Document-proof
import {documentProofRoutes} from './document-proof.router'

const masterRoutes: IRouteParent = {
  path: MASTER_URL.COMPANY,
  meta: {
    attrs: {
      module: MASTER_MODULE,
      icon: 'back-office/icon-master-data',
      label: 'backOffice.masterData',
      accessCodes: ACCESS_CODE_MASTER_DATA,
    },
  },
  children: [...companyRoutes, ...branchRoutes, ...roleRoutes, ...documentProofRoutes],
}

export { masterRoutes }
